
export function safeJsonStringify(jsonObject) {
    try {
        return JSON.stringify(jsonObject);
    } catch(err) {
        return "";
    }
}

export function safeJsonParse(jsonStr: string, defaultWhenException?: any): any {
    try {
        return JSON.parse(jsonStr);
    } catch(err) {
        return defaultWhenException || "";
    }
}